import { globals } from 'common-ui';
import type { CartItemProps } from 'tsconfig/types';
import { useAddToCartWithAtgLegacyApi } from './useAddToCartWithAtgLegacyApi';
import { useAddToCartWithWebApi } from './useAddToCartWithWebApi';

export function useActionAddToCart() {
  const addToCartWithAtgLegacyApi = useAddToCartWithAtgLegacyApi();
  const addToCartWithWebApi = useAddToCartWithWebApi();
  const { useNewCartAPI: isNewCartAPI } = globals;

  return async (items: CartItemProps[]): Promise<void> => {
    if (isNewCartAPI) {
      return addToCartWithWebApi(items);
    }
    const [{ itemCode, quantity }] = items; // Destructure the first item directly
    return addToCartWithAtgLegacyApi(itemCode, quantity.toString());
  };
}
